import {Injectable} from '@angular/core';
import {TranslateService as translateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {Observable} from 'rxjs';
import {FormValidationService} from './form-validation/form-validation.service';

@Injectable()
export class TranslateService {
    private _lang;
    private _dir;

    constructor(private translate: translateService,
                private formValidationService: FormValidationService,
                private location: Location,
                private router: Router) {
        if (localStorage.getItem('lang')) {
            this.lang = localStorage.getItem('lang');
        } else {
            this.lang = 'prs';
            localStorage.setItem('lang', 'prs');
        }
        translate.setDefaultLang('prs');
        if (localStorage.getItem('lang') === 'en') {
            this.translate.use('en');
        } else if (localStorage.getItem('lang') === 'prs') {
            this.translate.use('prs');
        } else if (localStorage.getItem('lang') === 'ps') {
            this.translate.use('ps');
        }
        document.querySelector('html').setAttribute('lang', this.lang);
        this.dir = this.lang === 'en' ? 'ltr' : 'rtl';
        this.formValidationService.setLang(this.lang);
    }

    public get lang() {
        return this._lang;
    }

    public set lang(val: string) {
        this._lang = val;
        localStorage.setItem('lang', val);
    }

    public get dir() {
        return this._dir;
    }

    public set dir(value: string) {
        this._dir = value;
    }

    normalize(key: string) {
        const keys = key.split('-');
        const value = [];
        for (let i = 0; i < keys.length; i++) {
            value[i] = keys[i].toUpperCase();
        }
        return value.join('_');
    }

    translateKey(value: any) {
        return this.translate.instant(value);
    }

    setDefaultLang(lang) {
        this.translate.setDefaultLang(lang);
    }

    use(lang): Observable<any> {
        return this.translate.use(lang);
    }

    get(value): Observable<any> {
        return this.translate.get(value);
    }

    onLangChange(): Observable<any> {
        return this.translate.onLangChange;
    }

    changeLang(lang: string) {
        localStorage.setItem('lang', lang);
        const path = this.location.prepareExternalUrl(this.location.path());
        const pathSplitParam = path.split('?');
        const pathSplitSlash = pathSplitParam[0].split('/');
        pathSplitSlash.splice(1, 1, lang);
        let params;
        const queryParamObject: any = {};
        if (pathSplitParam.length > 1) {
            params = pathSplitParam[1].split('&');
            for (const queryParam of params) {
                if (!queryParam.length) {
                    continue;
                }
                let key;
                let value;
                const paramSplit = queryParam.split('=');
                key = paramSplit[0];
                value = paramSplit[1];
                queryParamObject[key] = value;
            }
        }
        for (let i = 0; i < pathSplitSlash.length; i++) {
            pathSplitSlash[i] = decodeURIComponent(pathSplitSlash[i]);
        }
        const navigatePromise = params && Object.keys(params).length > 0 ?
            this.router.navigate(pathSplitSlash, {queryParams: params}) : this.router.navigate(pathSplitSlash);
        navigatePromise.then(() => window.location.reload());
    }
}
